import { useState, useEffect } from 'react';

export const useCheckOverflow = (
  ref: React.RefObject<HTMLElement>,
  active: boolean,
) => {
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    if (active && ref && ref.current) {
      const timeoutId = setTimeout(() => {
        setIsOverflow(ref!.current!.scrollWidth > ref!.current!.clientWidth);
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [active, ref]);

  return isOverflow;
};
